document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('accessories-recommendations');
  if (!wrapper) return;

  const productId = parseInt(wrapper.dataset.productId);

  // Auto-detect color from product title or variant
  function extractColors(text) {
    const colors = ['gold', 'silver', 'rose gold', 'black', 'white', 'nude', 'beige', 
                    'red', 'blue', 'green', 'pink', 'purple', 'brown', 'yellow', 'grey', 'gray'];
    const lowerText = text.toLowerCase();
    return colors.filter(color => lowerText.includes(color));
  }

  // Auto-detect style keywords
  function extractStyle(text) {
    const styles = ['elegant', 'formal', 'casual', 'party', 'wedding', 'evening', 
                    'floral', 'embellished', 'minimalist', 'bohemian', 'vintage', 
                    'modern', 'classic', 'romantic', 'chic'];
    const lowerText = text.toLowerCase();
    return styles.filter(style => lowerText.includes(style));
  }

  // Detect dress neckline type
  function detectNeckline(text) {
    const lowerText = text.toLowerCase();
    
    // High/covered necklines - NO NECKLACES
    if (lowerText.includes('high neck') || 
        lowerText.includes('turtleneck') || 
        lowerText.includes('halter') ||
        lowerText.includes('mock neck') ||
        lowerText.includes('crew neck')) {
      return 'high';
    }
    
    // Low/open necklines - NECKLACES OK
    if (lowerText.includes('v-neck') || 
        lowerText.includes('v neck') ||
        lowerText.includes('plunging') || 
        lowerText.includes('sweetheart') ||
        lowerText.includes('scoop') ||
        lowerText.includes('off shoulder') ||
        lowerText.includes('strapless') ||
        lowerText.includes('square neck')) {
      return 'low';
    }
    
    return 'unknown'; // Default - allow both
  }

  // Detect accessory type
function detectAccessoryType(text) {
  const lowerText = text.toLowerCase();

  if (lowerText.includes('necklace') || lowerText.includes('pendant') || lowerText.includes('choker')) {
    return 'necklace';
  }
  if (lowerText.includes('earring') || lowerText.includes('ear')) {
    return 'earrings';
  }
  if (lowerText.includes('ring')) {
    return 'ring';
  }
  if (lowerText.includes('scarf') || lowerText.includes('shawl')) {
    return 'scarf';
  }

  return 'other';
}

  // Check if accessory is compatible with dress neckline
  function isCompatible(dressNeckline, accessoryType) {
    // High neckline dresses - EXCLUDE necklaces
    if (dressNeckline === 'high' && accessoryType === 'necklace') {
      return false;
    }
    
    // All other combinations are OK
    return true;
  }

  // Calculate match score between dress and accessory
  function calculateMatchScore(dress, accessory, dressNeckline) {
    const accessoryType = detectAccessoryType(accessory.title);
    
    // First check compatibility
    if (!isCompatible(dressNeckline, accessoryType)) {
      return {
        score: -100, // Negative score to filter out
        colorMatches: [],
        styleMatches: [],
        incompatible: true
      };
    }
    
    let score = 0;
    
    // Boost earrings for high-neck dresses
    if (dressNeckline === 'high' && accessoryType === 'earrings') {
      score += 15; // Extra bonus for earrings with high-neck
    }
    
    // Boost necklaces for low-neck dresses
    if (dressNeckline === 'low' && accessoryType === 'necklace') {
      score += 10; // Bonus for necklaces with low-neck
    }
    
    // Color matching (highest priority)
    const dressColors = extractColors(dress.title);
    const accessoryColors = extractColors(accessory.title);
    const colorMatches = dressColors.filter(color => accessoryColors.includes(color));
    score += colorMatches.length * 10; // 10 points per color match

    // Style matching
    const dressStyles = extractStyle(dress.title);
    const accessoryStyles = extractStyle(accessory.title);
    const styleMatches = dressStyles.filter(style => accessoryStyles.includes(style));
    score += styleMatches.length * 5; // 5 points per style match

    // Price range matching (similar price = better match)
    const dressPrice = dress.variants[0]?.price || 0;
    const accessoryPrice = accessory.variants[0]?.price || 0;
    const priceDiff = Math.abs(dressPrice - accessoryPrice) / dressPrice;
    if (priceDiff < 0.5) score += 3; // Within 50% price range

    // Variety bonus - prefer diverse accessory types
    if (accessoryType === 'shoes') score += 8; // Always show shoes
    if (accessoryType === 'bag') score += 7; // Always show bag
    if (accessoryType === 'earrings') score += 6; // Earrings are versatile

    // Add slight randomization to vary results
    score += Math.random() * 2;

    return {
      score,
      colorMatches,
      styleMatches,
      accessoryType
    };
  }

  async function renderAccessories() {
    const list = wrapper.querySelector('.accessories-recommendations__list');
    if (!list) return;

    list.innerHTML = '<p>Loading accessories...</p>';

    try {
      // Fetch current product details
      const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      const productRes = await fetch(`/products/${productHandle}.json`);
      const productData = await productRes.json();
      const currentProduct = productData.product;
      
      const dressNeckline = detectNeckline(currentProduct.title);
      
      console.log('Current dress:', currentProduct.title);
      console.log('Neckline type:', dressNeckline);
      console.log('Detected colors:', extractColors(currentProduct.title));
      console.log('Detected styles:', extractStyle(currentProduct.title));

      // Fetch accessories collection
      const res = await fetch(`/collections/accessories/products.json`);
      const data = await res.json();
      
      // Exclude current product
      let accessories = data.products.filter(p => p.id !== productId);
      
      console.log('Total accessories available:', accessories.length);

      // Calculate match score for each accessory
      const scoredAccessories = accessories.map(accessory => {
        const matchData = calculateMatchScore(currentProduct, accessory, dressNeckline);
        return {
          ...accessory,
          matchScore: matchData.score,
          matchDetails: matchData
        };
      });

      // Filter out incompatible items and sort by match score
const allowedTypes = ['necklace', 'earrings', 'ring', 'scarf'];

const bestMatches = scoredAccessories
  .filter(a => 
    a.matchScore > 0 &&
    allowedTypes.includes(a.matchDetails.accessoryType)
  )
  .sort((a, b) => b.matchScore - a.matchScore)
  .slice(0, 4);

      console.log('Best matches:', bestMatches.map(a => ({
        title: a.title,
        type: a.matchDetails.accessoryType,
        score: a.matchScore,
        colors: a.matchDetails.colorMatches,
        styles: a.matchDetails.styleMatches
      })));

      if (bestMatches.length === 0) {
        list.innerHTML = '<p>No accessories available.</p>';
        return;
      }

      // Render accessories
list.innerHTML = bestMatches.map(a => {
  const imageUrl = a.images?.[0]?.src || '';
  const variantId = a.variants?.[0]?.id;

const price = a.variants && a.variants.length > 0
  ? `$${parseFloat(a.variants[0].price).toFixed(2)} USD`
  : '';

  return `
    <div class="accessory-item">
      <div class="accessory-image-wrapper">
        <img src="${imageUrl}" alt="${a.title}" loading="lazy" class="accessory-image">
      </div>

      <div class="accessory-details">
        <h3 class="accessory-title">${a.title}</h3>
        <p class="accessory-price">${price}</p>
      </div>

      <button 
        class="accessory-add-btn"
        data-variant-id="${variantId}">
        ADD TO CART
      </button>
    </div>
  `;
}).join('');

    } catch (err) {
      console.error('Error fetching accessories:', err);
      list.innerHTML = '<p>Failed to load accessories.</p>';
    }
  }

  renderAccessories();
  document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.accessory-add-btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'ADDING...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    btn.textContent = 'ADDED ✓';

    // Optional: open cart drawer if your theme supports it
    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (err) {
    console.error('Add to cart failed', err);
    btn.textContent = 'ERROR';
  }

  setTimeout(() => {
    btn.textContent = 'ADD TO CART';
    btn.disabled = false;
  }, 2000);
});

});